import { bsc, goerli, mainnet, polygon } from '@wagmi/chains';
import { Chain, configureChains, createClient } from 'wagmi';
import { CoinbaseWalletConnector } from 'wagmi/connectors/coinbaseWallet';
import { MetaMaskConnector } from 'wagmi/connectors/metaMask';
import { WalletConnectConnector } from 'wagmi/connectors/walletConnect';
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc';
import { publicProvider } from 'wagmi/providers/public';

// Configure chains & providers with the Alchemy provider.
// Two popular providers are Alchemy (alchemy.com) and Infura (infura.io)

const networks: { [chainId: number]: Chain } = {
  1: {
    ...mainnet,
    rpcUrls: {
      default: 'https://ethereum.publicnode.com',
      cloudfare: 'https://cloudflare-eth.com',
      rpcBuilder: 'https://rpc.builder0x69.io',
    },
  },
  5: {
    ...goerli,
    rpcUrls: {
      default: 'https://rpc.ankr.com/eth_goerli',
    },
  },
  56: {
    ...bsc,
    rpcUrls: { default: 'https://bscrpc.com' },
  },
  137: {
    ...polygon,
    rpcUrls: {
      default: 'https://polygon-rpc.com',
      maticVigil: 'https://rpc-mainnet.maticvigil.com',
      blastApi: 'https://polygon-mainnet.public.blastapi.io',
      pokt: 'https://poly-rpc.gateway.pokt.network',
      publicBor: 'https://polygon-bor.publicnode.com',
    },
  },
};
const POLLING_INTERVAL = 12_000;

const { chains, provider } = configureChains(
  Object.values(networks),
  [
    jsonRpcProvider({
      rpc: chain => ({ http: chain.rpcUrls.default }),
    }),
    publicProvider(),
  ],
  {
    pollingInterval: POLLING_INTERVAL,
  },
);

// Set up client
export const client = createClient({
  autoConnect: true,
  connectors: [
    new MetaMaskConnector({ chains }),
    new CoinbaseWalletConnector({
      chains,
      options: {
        appName: 'wagmi',
      },
    }),
    new WalletConnectConnector({
      chains,
      options: {
        qrcode: true,
      },
    }),
  ],
  provider,
});
